export const POINT_STATUSES = () => ({
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
  DENIED: 'DENIED',
});

export const POINT_TYPES = () => ({
  RESERVATION: 'RESERVATION',
  REVIEW: 'REVIEW',
  REFERRAL: 'REFERRAL',
  APOLOGY: 'APOLOGY',
  DEDUCT: 'DEDUCT',
});



// WEBPACK FOOTER //
// ./src/app/customers/customers.constants.js